export class AdminBoxSaleApproveStatusOrders {
  public constructor(
    private readonly data: {
      paid: number;
      partiallyCompleted: number;
      partiallyRefunded: number;
    },
  ) {}

  public get paid(): number {
    return this.data.paid;
  }

  public get partiallyCompleted(): number {
    return this.data.partiallyCompleted;
  }

  public get partiallyRefunded(): number {
    return this.data.partiallyRefunded;
  }
}
